import * as Excel from "exceljs";
import FileSaver from "file-saver";
import { models } from "types/api/viewModels";
import { getFileNameBasedOnCurrentDateTime } from "utils/file";
import { checkForAndReplaceNullEmptyWhitespace, convertToTitleCase } from "utils/string";
import { dateFormat } from "utils/date";
import { ReplacmentConfirmationOrderPending, TruckPendingText, UnavailableDataPlaceholderText } from "constants/text";

export function convertProcessedTrucksToExcel(processedTrucks: models["TruckViewModel"][]) {
	return processedTrucks.map((truck) => ({
		"Truck Number": truck.truckNumber ?? TruckPendingText,
		"Truck Name": checkForAndReplaceNullEmptyWhitespace(truck.truckName),
		"Account Number": checkForAndReplaceNullEmptyWhitespace(truck.stops?.[0]?.orders?.[0]?.accountNumber),
		"Account Name": checkForAndReplaceNullEmptyWhitespace(truck.accountName),
		"Product Line": checkForAndReplaceNullEmptyWhitespace(truck.productLine?.description),
		"Truck Status": checkForAndReplaceNullEmptyWhitespace(convertToTitleCase(truck.truckStatus)),
		"Order Date": checkForAndReplaceNullEmptyWhitespace(dateFormat(String(truck.submittedOn))),
		"Requested Delivery Date": checkForAndReplaceNullEmptyWhitespace(
			dateFormat(String(truck.requestedDeliveryDate))
		),
		"Estimated Delivery Date": truck.stops?.[0]?.orders?.[0]?.eta
			? dateFormat(String(truck.stops[0].orders[0].eta))
			: ReplacmentConfirmationOrderPending,
		"Cabinet Count": truck.cabinetCount ?? UnavailableDataPlaceholderText,
		"Cubes Count": truck.cubeCount ?? UnavailableDataPlaceholderText,
		"Cubes Available": truck.cubeCapacity ?? UnavailableDataPlaceholderText
	}));
}

export async function generateProcessedTrucksExcel(processedTrucks: models["TruckViewModel"][] | undefined) {
	const workbook = new Excel.Workbook();
	const trucksWorksheet = workbook.addWorksheet("Trucks");

	const trucksInfo = convertProcessedTrucksToExcel(processedTrucks ?? []);

	if (trucksInfo.length > 0) {
		trucksWorksheet.columns = Object.keys(trucksInfo[0] ?? {}).map((col) => {
			return { key: col, header: col };
		});
		trucksWorksheet.addRows(trucksInfo);
	}

	try {
		workbook.xlsx.writeBuffer().then((data) => {
			const blob = new Blob([data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
			});
			FileSaver.saveAs(blob, `${getFileNameBasedOnCurrentDateTime("ProcessedTrucks")}.xlsx`);
		});
	} catch (e) {
		console.error("Error trying to generate processed trucks xlsx file", e);
	}
}
